/**
 * Le schede dell'aiuto (GI-281): manuale, glossario, tasti.
 *
 * Tre cose che prima stavano in tre posti diversi — il manuale nel
 * repository, dove un operatore non arriva; il glossario dietro il segno «?»;
 * la mappa dei tasti dietro un tasto che nessuno sapeva di poter premere.
 * Ora sono un modulo con le sue schede, col vestito dei moduli della
 * commessa e dell'amministrazione: chi ha imparato quelli riconosce questo.
 *
 * La scheda dei tasti c'e' solo per chi decide al banco: per gli altri e'
 * un elenco di gesti che non possono compiere.
 */
import { NavLink } from 'react-router-dom'

import { REVIEW_QUEUE, type Whoami } from '../auth'
import { useT } from '../i18n/LocaleProvider'
import type { MessageKey } from '../i18n/messages'

const TABS: { to: string; name: MessageKey; need: string | null }[] = [
  { to: '/aiuto', name: 'aiuto.manual', need: null },
  { to: '/glossario', name: 'title.glossary', need: null },
  { to: '/aiuto/tasti', name: 'keys.help', need: REVIEW_QUEUE },
]

/** Se l'indirizzo sta dentro il modulo dell'aiuto. */
export function isAiutoScreen(pathname: string): boolean {
  return pathname.startsWith('/aiuto') || pathname.startsWith('/glossario')
}

export function AiutoTabs({ who }: { who: Whoami }): JSX.Element {
  const t = useT()
  return (
    <nav className="workspace-tabs workspace-tabs-admin" aria-label={t('aiuto.sections')}>
      <span className="workspace-modulo">{t('rail.help')}</span>
      {TABS.filter((one) => one.need === null || who.may.includes(one.need)).map((one) => (
        <NavLink
          key={one.to}
          to={one.to}
          end
          className={({ isActive }) => (isActive ? 'workspace-tab on' : 'workspace-tab')}
        >
          {t(one.name)}
        </NavLink>
      ))}
    </nav>
  )
}
